<template>
  <div>
    <b-row>
      <b-col class="px-5">
        <h2>What's your interest for travel ?</h2>
        <i>You can choose more than one interest</i>
      </b-col>
    </b-row>

    <b-row class="justify-content-center mt-3">
      <b-col class="py-2 px-3" cols="5" v-for="(x, i) in interest_options" :key="i">
        <div class="p-3 sg-badge-selection" :class="{ selected: inArray(arrInterest, x._id), selected_temp: inArray(interest_temp, x._id) }" @click="setInterestTemp(x._id)">
          {{ x.interest }}
        </div>
      </b-col>
    </b-row>

    <b-row class="mt-3 justify-content-center">
      <b-col cols="4">
        <!-- DISABLED BUTTON KALAU TIDAK ADA INTEREST YANG DIPILIH -->
        <b-button variant="success" size="lg" block @click="setInterest">Update</b-button>
        <!-- DISABLED BUTTON KALAU INTEREST LEBIH DARI 3 -->
      </b-col>
    </b-row>
  </div>
</template>

<script>
// external dependencies

// custom component

// api call

export default {
  name: 'Order_ModalInterest',
  props: ['interest', 'interest_options'],
  components: {
  },
  data () {
    return {
      arrInterest: [], // clone dari order_data.interest (untuk bikin observer, buat selected interest)

      // CHECK APAKAH SETIAP MUNCUL INTEREST_TEMP NYA KE HAPUS
      interest_temp: [] // penampung sebelum di 'Update'
    }
  },
  mounted: function () {
    // clone order_data.interest => arrInterest
    for (let i = 0; i < this.interest.length; i++) {
      this.arrInterest.push(this.interest[i])
    }
  },
  methods: {
    // PREREQUISITES
    inArray: function (arr, needle) {
      var length = arr.length
      for (var i = 0; i < length; i++) {
        if (arr[i] === needle) return true
      }
      return false
    },
    removeArray: function (arr, needle) {
      for (var i = 0; i < arr.length; i++) {
        if (arr[i] === needle) {
          arr.splice(i, 1)
        }
      }
    },
    setInterestTemp: function (value) {
      if (this.inArray(this.arrInterest, value)) {
        // yg sudah ada di order_data.interest dihapus (untuk menghilangkan selected interest)
        this.removeArray(this.arrInterest, value)
      } else {
        // nambah ke temporary
        if (!this.inArray(this.interest_temp, value)) this.interest_temp.push(value)
        // remove dr temporary
        else this.removeArray(this.interest_temp, value)
      }
    },
    setInterest: function () {
      const self = this
      // masukin temporary ke clone
      self.interest_temp.forEach(x => {
        self.arrInterest.push(x)
      })

      self.$emit('setInterest', self.arrInterest)
    }
    // END PREREQUISITES

    // HTTP REQUEST
    // END HTTP REQUEST
  }
}
</script>

<style scoped>
.sg-badge-selection {
  background-color: #dddddd;
  border: 3px solid #dddddd;
  border-radius: 5px;
  cursor: pointer;

  padding: 10px;
  font-size: 18px;
  text-align: center;
}
.sg-badge-selection.selected {
  border: 3px solid #919dbd;
  background-color: #c8cede;
}
.selected_temp,
.sg-badge-selection:hover {
  border: 3px solid #233c7c;
}
</style>



// WEBPACK FOOTER //
// src/components/Order/ModalInterest/ModalInterest.vue